import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import { createBootstrap } from "bootstrap-vue-next";
// Add the necessary CSS (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";

let myApp = createApp(App);
myApp.use(router);
myApp.use(createBootstrap({ components: true, directives: true }));
myApp.mount("#app");
